import { useDispatch, useSelector } from "react-redux";
import { setNotification, SeverityTypes } from "./notificationSlice";
import { RootState } from "../../state";

export default function NotificationService() {
  const dispatch = useDispatch();
  const data = useSelector((state: RootState) => state.notification);

  const success = (msg: string) => {
    let severity = SeverityTypes.SUCCESS;
    let errorMessage = msg;
    dispatch(
      setNotification({
        open: true,
        message: errorMessage,
        severity: severity,
      }),
    );
  };

  const error = (msg: string) => {
    let severity = SeverityTypes.ERROR;
    let errorMessage = msg;
    dispatch(
      setNotification({
        open: true,
        message: errorMessage,
        severity: severity,
      }),
    );
  };

  const warning = (msg: string) => {
    let severity = SeverityTypes.WARNING;
    let errorMessage = msg;
    dispatch(
      setNotification({
        open: true,
        message: errorMessage,
        severity: severity,
      }),
    );
  };

  const info = (msg: string) => {
    let severity = SeverityTypes.INFO;
    let errorMessage = msg;
    dispatch(
      setNotification({
        open: true,
        message: errorMessage,
        severity: severity,
      }),
    );
  };

  const close = () => {
    dispatch(
      setNotification({
        open: false,
        message: data.message,
        severity: data.severity,
      }),
    );
  };

  return {
    success,
    error,
    warning,
    info,
    close,
  };
}
